import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';

import { sortByName } from 'utils/array';

import {
  ProjectTag,
  Team,
  TeamService,
  TeamServiceTag,
  TeamServiceWithTeam,
  TeamWithCollections,
} from './types';
import { userLoaders } from '../users';

const baseLoaders = getLoaders({
  list: {
    load: async (): Promise<Team[]> => {
      return executeApiCall({
        path: '/teams',
        method: 'get',
      });
    },

    defaultParser: sortByName,
  },

  find: {
    load: async ({ id }: { id: string }): Promise<TeamWithCollections> => {
      return executeApiCall({
        path: `/teams/${id}`,
        method: 'get',
      });
    },
  },

  projectTags: {
    load: async ({ teamId }: { teamId: string }): Promise<Array<ProjectTag & { id: string }>> => {
      return executeApiCall({
        path: `/teams/${teamId}/project-tags`,
        method: 'get',
        payload: {
          active: true,
        },
      });
    },
  },

  allServices: {
    load: async (): Promise<TeamServiceWithTeam[]> => {
      return executeApiCall({
        path: '/teams/services',
        method: 'get',
      });
    },
  },

  serviceTags: {
    load: async ({ serviceId }: { serviceId: string }): Promise<TeamServiceTag[]> => {
      return executeApiCall({
        path: `/teams/services/${serviceId}/tags`,
        method: 'get',
      });
    },
  },

  findService: {
    load: async ({ id }: { id: string }): Promise<TeamService> => {
      return executeApiCall({
        path: `/teams/services/${id}`,
        method: 'get',
      });
    },
  },
});

export const teamLoaders = {
  ...baseLoaders,

  teamUsers: userLoaders.teamUsers,
};
